const NEUMORPHISM_BASE_SHADOW = `
  -2.82px -2.82px 8.49px 0px #FFFFFF4D,
  14.15px 14.15px 22.64px -0.37px #0000001A,
  -17.54px -17.54px 28.66px 0px #FFFFFF0D,
  10px 10px 28.66px -11.7px #00000033,
  1.58px 1.58px 1.7px 0px #FFFFFF inset,
  -2.07px -2.64px 4.52px -1.51px #0000004D inset
`;

const NEUMORPHISM_HOVER_SHADOW = `
  14.15px 14.15px 22.64px -0.37px #00FFFF21,
  -17.54px -17.54px 28.66px 0px #A6FFFF30,
  10px 10px 28.66px -11.7px #00929233,
  0 0 0 0 transparent,
  1.58px 1.58px 1.7px 0px #A3FFFF inset,
  -2.07px -2.64px 4.52px -1.51px #00929252 inset
`;

const BACK_BUTTON_SHADOW_BASE = `
  0px 0px 16px 0px #5C5C5C4D inset,
  0px 0px 3px 0px #FFFFFF66 inset,
  -1px -1px 0.5px -1px #FFFFFF inset,
  1px 1px 0.5px -1px #FFFFFF66 inset,
  -1px -1px 0px -0.5px #FFFFFF80 inset,
  1px 1px 0px -0.5px #FFFFFF99 inset,
  0px 1px 8px 0px #0000001F,
  0px 0px 2px 0px #0000001A
`;

const BACK_BUTTON_SHADOW_HOVER = ` 
  0px 0px 16px 0px rgba(132, 132, 132, 0.3) inset,
  0px 0px 3px 0px rgba(0, 232, 231, 0.44) inset,
  -1px -1px 0.5px -1px rgba(255, 255, 255, 1) inset,
  1px 1px 0.5px -1px rgba(255, 255, 255, 0.7) inset,
  -1px -1px 1px -0.5px rgba(255, 255, 255, 0.65) inset,
  1px 1px 0px -0.5px rgba(255, 255, 255, 0.6) inset,
  0px 1px 8px 0px rgba(0, 0, 0, 0.12),
  0px 0px 2px 0px rgba(0, 0, 0, 0.1)
`;

const BACK_BUTTON_SHADOW_ACTIVE = `
  0px 0px 3px 0px rgba(0, 232, 231, 0.34),
  1px 1px 0px -1px rgba(255, 255, 255, 1) inset,
  1px 1px 0px -0.5px rgba(225, 225, 225, 0.6),
  0px 1px 4px 0px rgba(0, 0, 0, 0.3) inset,
  0px 0px 2px 0px rgba(0, 0, 0, 0.1) inset
`;

export const CATEGORY_CARD_BASE_SX = {
  boxShadow: NEUMORPHISM_BASE_SHADOW,
  transition: 'box-shadow 0.3s ease, opacity 0.3s ease-in-out',
  borderRadius: '64px',
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.9,
    boxShadow: NEUMORPHISM_HOVER_SHADOW,
  },
};

export const SUB_CATEGORY_CARD_BASE_SX = {
  boxShadow: NEUMORPHISM_BASE_SHADOW,
  transition: 'box-shadow 0.3s ease, opacity 0.3s ease-in-out',
  borderRadius: '64px',
  padding: '24px',
  gap: '8px',
  aspectRatio: 1,
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.9,
    boxShadow: NEUMORPHISM_HOVER_SHADOW,
  },
};

export const BACK_BUTTON_BASE_SX = {
  padding: '8px 24px',
  fontSize: '16px',
  lineHeight: '32px',
  fontFamily: 'Montserrat',
  fontWeight: '500',
  textAlign: 'center',
  width: 'auto',
  margin: '0 auto',
  borderRadius: '64px',
  height: '48px',
  background: 'rgba(132, 132, 132, 0.2)',
  backdropFilter: 'blur(12px)',
  boxShadow: BACK_BUTTON_SHADOW_BASE,
  '&&:hover': {
    backgroundColor: 'rgba(132, 132, 132, 0.2)',
    boxShadow: BACK_BUTTON_SHADOW_HOVER,
  },
  '&&:focus-visible': {
    backgroundColor: 'rgba(132, 132, 132, 0.2)',
    border: '1px solid rgba(57, 57, 57, 1))',
    outline: 'none',
  },
  '&&:active': {
    backgroundColor: 'rgba(132, 132, 132, 0.2)',
    boxShadow: BACK_BUTTON_SHADOW_ACTIVE,
  },
};
